import * as React from "react";
import image from "../assets/logo.png";
import imagearshe from "../assets/logonew.png";
import { StyleSheet } from 'react-native';
import { fontSize } from "@mui/system";
import { useTranslation } from 'react-i18next';
import i18n from '../assets/lang/i18next';


const styles = StyleSheet.create({
    flash: {
        width: '100%', backgroundColor: '#000'
    },
    testClass: {
        backgroundColor: 'red'
    }
})
export class ComponentToPrintEvaprator extends React.PureComponent {

    constructor(props) {

        super(props);

        this.state = { checked: false };
    }

    canvasEl;

    componentDidMount() {
        const ctx = this.canvasEl.getContext("2d");
        if (ctx) {
            ctx.beginPath();
            ctx.arc(95, 50, 40, 0, 2 * Math.PI);
            ctx.stroke();
            ctx.fillStyle = "rgb(200, 0, 0)";
            ctx.fillRect(85, 40, 20, 20);
            ctx.save();
        }
    }

    handleCheckboxOnChange = () =>
        this.setState({ checked: !this.state.checked });

    setRef = (ref) => (this.canvasEl = ref);

    render() {
        const { text } = this.props;
        return (


            <div style={{ backgroundColor: 'white', width: '100%', fontFamily: 'IranSans' }}>
                <style type="text/css" media="print">
                    {"\   @page  {  size: A4 portrait; margin:3mm 15mm 0mm 15mm}\
"}
                </style>

                <div />

                <div style={{ backgroundColor: '#022a4c', border: 'none', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: 10, height: 50, flexWrap: 'wrap' }}>
                    <img alt="arshehar" src={image} width="50" height="50" />

                    <div align="center" style={{ marginRight: -80 }}>
                        <h2 style={{ color: 'white', fontSize: 16, margin: 0, padding: 0 }}>شرکت آرشه کار</h2>
                        <p style={{ color: 'white', fontSize: 13, margin: 0, padding: 0 }}>تولید و تجهیز سیستم های برودتی</p>
                    </div>
                    <img alt="arshehar" src={imagearshe} height="35" width="150" style={{ paddingTop: 7 }} />

                </div>

                <div align="center" style={{ margin: 4 }}>

                    <img alt="arshehar" src={this.props.person.axevaprator} height="170" />
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', direction: 'rtl' }}>
                    <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none', display: 'flex', flexDirection: 'column', paddingLeft: 4 }}>
                        <div style={{ backgroundColor: '#a5a5a5', width: '100%', padding: 3 }}>
                            <h4 style={{ fontSize: 12, margin: 0, padding: 2, width: '100%' }}>{i18n.t('AirColledEvaporator')}</h4>
                        </div>
                        <tbody>
                            <tr style={{ display: 'none' }}>
                                <td>Canvass</td>
                                <td>
                                    <canvas height="100" ref={this.setRef} width="200">
                                    </canvas>
                                </td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Model')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.selectedmodeltitle}</p> </td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('refrigerant')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.mobared}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Nominalcapacity')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.zarfiyatnami} KW</p> </td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('EvaporatorType')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{i18n.t('Cubic')}</p> </td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Weight')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.vazn} kg</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Pressuretesting')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{i18n.t('400Psi')}</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Pressurefilled')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{i18n.t('150Psi')}</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('TerminalBoxIp')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{i18n.t('IP66')}</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}> </p></td>
                            </tr>
                            
                        </tbody>
                    </table>
                    <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none', display: 'flex', flexDirection: 'column', paddingRight: 4 }}>
                        <div style={{ backgroundColor: '#a5a5a5', width: '100%', padding: 3 }}>
                            <h4 style={{ fontSize: 12, margin: 0, padding: 2, width: '100%' }}>{i18n.t('CoilSpecification')}</h4>
                        </div>
                        <tbody>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('surfaceareaofheattransfer')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.sathtabadolhararat} M<sup>2</sup></p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Circuitvol')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.gazgiri} liter </p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Tubes')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{i18n.t('Copper')}</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Fines')}</p> </td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{i18n.t('Aluminum')}</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Finspace')}</p> </td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.faselefin} mm</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Inlet')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.vorodi} inch</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Outlet')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.khoroji} inch</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('CoverCoated')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{i18n.t('ElectorstaticPowder')}</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('TubeStyle')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{i18n.t('Staggered')}</p></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none', display: 'flex', flexDirection: 'column', paddingRight: 5 }}>
                        <div style={{ backgroundColor: '#a5a5a5', width: '100%', padding: 3 }}>
                            <h4 style={{ fontSize: 12, margin: 0, padding: 2, width: '100%' }}>{i18n.t('electricdefrostspecification')}</h4>
                        </div>
                        <tbody>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Current')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.jaryandefrost} A</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Voltage')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.voltajdefrost} V</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Power')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.tavandefrost} KW</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}> </p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}> </p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}> </p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}> </p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}> </p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}> </p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}> </p></td>
                            </tr>
                        </tbody>
                    </table>
                    <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none', display: 'flex', flexDirection: 'column', paddingLeft: 5 }}>
                        <div style={{ backgroundColor: '#a5a5a5', width: '100%', padding: 3 }}>
                            <h4 style={{ fontSize: 12, margin: 0, padding: 2, width: '100%' }}>{i18n.t('fanspecifications')}</h4>
                        </div>
                        <tbody>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Nooffans')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.tedadfan}</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('FanDiameter')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.sizefan} cm</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Airflow')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.debi} m<sup>3</sup>/h</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Airthrow')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.partabbad} m</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('speed')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.sorat}  RPM</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>IP</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.ip}</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Voltage')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.voltajfan} V</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Frequency')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.ferekans} Hz</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Current')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.jaryanfan} A</p></td>
                            </tr>
                            <tr>
                                <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('Power')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>{this.props.person.tavanfan} KW</p></td>
                            </tr>
                            {
                                this.props.person.selectedmodeltitle.substring(0, 2) == "EC" || this.props.person.selectedmodeltitle.substring(0, 2) == "evc" ? "" : <tr >
                                    <td><p style={{ fontSize: 12, padding: 2, margin: 0 }}>{i18n.t('FanBrand')}</p></td>
                                    <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, paddingRight: 20 }}>ebm-papst/Ziehl-Abegg(Germany)</p></td>
                                </tr>

                            }


                        </tbody>
                    </table>
                </div>








                <hr></hr>
                <div style={{ direction: 'rtl', textAlign: 'right', fontSize: 11 }}>
                    <p style={{ margin: 0 }}>{i18n.t('DimensionsinMillimeter')}</p>
                    <p style={{ margin: 0 }}>{i18n.t('NominalCapacityisCalculatedon')}</p>
                    <hr></hr>
                    <ul>
                        <li>{i18n.t('line1evp')}</li>
                        <li>{i18n.t('line2evp')}</li>
                        <li>{i18n.t('line3evp')}</li>
                        <li>{i18n.t('line4evp')}</li>
                        <li>{i18n.t('line5evp')}</li>
                        <li>{i18n.t('line6evp')}</li>
                        <li>{i18n.t('line7evp')}</li>
                        <li>{i18n.t('line8evp')}</li>

                    </ul>
                </div>



                <div style={{ backgroundColor: 'red', width: '100%', height: 35, direction: 'ltr', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <h3 style={{ color: 'white', marginLeft: 10, fontSize: 13 }}><a style={{ color: 'white' }} href="https://app.arshehkar.com">app.arshehkar.com</a></h3>
                    <h3 style={{ color: 'white', marginRight: 20, fontSize: 13 }}><a style={{ color: 'white' }} href="mailto:info@arshehkar.com">info@arshehkar.com</a></h3>
                </div>
            </div>


        );
    }
}

export const FunctionalComponentToPrintEvaprator = React.forwardRef((props, ref) => {
    // eslint-disable-line max-len
    return <ComponentToPrintEvaprator ref={ref} text={props.text} />;
});
